import { render, staticRenderFns } from "./initLocation.vue?vue&type=template&id=596c2c66&scoped=true&"
import script from "./initLocation.vue?vue&type=script&lang=js&"
export * from "./initLocation.vue?vue&type=script&lang=js&"
import style0 from "./initLocation.vue?vue&type=style&index=0&id=596c2c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c2c66",
  null
  
)

export default component.exports